import axios from "axios";

export const getAuthors = async (params) => {
    try {
        let { data } = await axios.get(`${process.env.REACT_APP_API_URL}/authors`,{params});
        return data
    } catch (error) {
        return error?.response?.data
    }
}